export default [
  {
    name: 'Roles',
    path: '/acl/roles',
    component: () => import('@/modules/acl/roles/pages/Roles'),
    meta: {
      ability: [
        {
          resource: 'roles',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Add Role',
    path: '/acl/roles/add',
    component: () => import('@/modules/acl/roles/pages/RoleDetails'),
    meta: {
      ability: [
        {
          resource: 'roles',
          actions: ['create'],
        },
        {
          resource: 'acl_entities',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Edit Role',
    path: '/acl/roles/edit/:id',
    component: () => import('@/modules/acl/roles/pages/RoleDetails'),
    props: {
      editMode: true,
    },
    meta: {
      ability: [
        {
          resource: 'roles',
          actions: ['update'],
        },
        {
          resource: 'acl_entities',
          actions: ['read'],
        },
      ],
    },
  },
]
